import React from 'react';
import Text from '@amzn/meridian/text';
import DisplaySubMetric from './DisplaySubMetric';
import Row from '@amzn/meridian/row';
import { FormattedMessage } from 'react-intl';
import { DisplaySubMetricsProps } from '../types';
import {
  SDRDataCheck,
  SUBMETRIC_FONT_SIZE,
  SUBMETRIC_ROW_WIDTHS,
} from '../helper';
import { ControlledExpander } from './Util/ControlledExpander';
import Column from '@amzn/meridian/column';
import NoSubMetric from './Util/NoSubMetric';

const DisplaySDRSubMetrics: React.FC<DisplaySubMetricsProps> = ({
  metrics,
}: DisplaySubMetricsProps): React.ReactElement => {
  if (!metrics.SDR?.submetrics) {
    return <></>;
  }
  if (SDRDataCheck(metrics.SDR?.submetrics!)) {
    return <NoSubMetric />;
  }
  const { sdrDenominator, sdrYes } = metrics.SDR?.submetrics!;

  return (
    <Column spacing='none' width='100%'>
      {sdrDenominator && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_sdrDenominator'
                  defaultMessage='SDR Denominator'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_sdrDenominator_def'
                defaultMessage='Sum of total contacts that were handled.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric value={sdrDenominator.datapoint} isBold />
          <DisplaySubMetric
            value={sdrDenominator.networkAverage}
            datapointNull={sdrDenominator.datapoint === null}
          />
        </Row>
      )}
      {sdrYes && (
        <Row
          alignmentVertical='top'
          width='100%'
          widths={SUBMETRIC_ROW_WIDTHS}
          spacing='none'
          spacingInset='none none 200'
        >
          <ControlledExpander
            title={
              <Text type={SUBMETRIC_FONT_SIZE}>
                <FormattedMessage
                  id='cs_perfportal_lighthouse_sdrSuccess'
                  defaultMessage='SDR Yes/Success'
                />
              </Text>
            }
            type='list'
          >
            <Text type={SUBMETRIC_FONT_SIZE}>
              <FormattedMessage
                id='cs_perfportal_lighthouse_sdrSuccess_def'
                defaultMessage='Sum of contacts which resulted in same day delivery repeat.'
              />
            </Text>
          </ControlledExpander>
          <DisplaySubMetric value={sdrYes.datapoint} isBold />
          <DisplaySubMetric
            value={sdrYes.networkAverage}
            datapointNull={sdrYes.datapoint === null}
          />
        </Row>
      )}
    </Column>
  );
};

export default DisplaySDRSubMetrics;
